module.exports = __webpack_public_path__ + "static/themeable_12_months_with_list-8a558ae78fd4d5d628de2fd485b58c0d.png";